import assetPath from '/app/packages/lebenslauf/articles/src/assets/vom-ersten-wort-an-ueberzeugen-die-richtige-schriftart-fuer-deine-bewerbung.jpg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')